<template>
  <div class="header__filter">
    <div class="header__filter-item">
      <Dropdown
        :value="view.start_date_field"
        :disabled="readOnly"
        :show-search="true"
        @input="cambiar('start_date_field', $event)"
      >
        <DropdownItem name="Inicio: sin campo" :value="null"></DropdownItem>
        <DropdownItem
          v-for="c in camposDeFecha"
          :key="'i' + c.id"
          :name="'Inicio: ' + c.name"
          :value="c.id"
        ></DropdownItem>
      </Dropdown>
    </div>
    <div class="header__filter-item">
      <Dropdown
        :value="view.end_date_field"
        :disabled="readOnly"
        :show-search="true"
        @input="cambiar('end_date_field', $event)"
      >
        <DropdownItem name="Fin: sin campo" :value="null"></DropdownItem>
        <DropdownItem
          v-for="c in camposDeFecha"
          :key="'f' + c.id"
          :name="'Fin: ' + c.name"
          :value="c.id"
        ></DropdownItem>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import { camposDeFecha } from '@extras_mg/utils/campos'
import Dropdown from '@baserow/modules/core/components/Dropdown'
import DropdownItem from '@baserow/modules/core/components/DropdownItem'
import { notifyIf } from '@baserow/modules/core/utils/error'

export default {
  name: 'TimelineViewHeader',
  components: { Dropdown, DropdownItem },
  props: {
    database: { type: Object, required: true },
    view: { type: Object, required: true },
    table: { type: Object, required: true },
    fields: { type: Array, required: true },
    readOnly: { type: Boolean, required: true },
    storePrefix: { type: String, required: false, default: '' },
  },
  computed: {
    camposDeFecha() {
      return camposDeFecha(this.fields)
    },
  },
  methods: {
    async cambiar(campo, valor) {
      try {
        await this.$store.dispatch('view/update', {
          view: this.view,
          values: { [campo]: valor },
        })
      } catch (e) {
        notifyIf(e, 'view')
      }
    },
  },
}
</script>
